import React, { useEffect, useState } from "react";
import _, { ceil } from "lodash";
// htmlText = نمایش
// showIcon = نمایش ایکن
//copyDate = دیتا کپی شده
const CopyToClipboard = ({ htmlText, showIcon, copyDate }) => {
  const [showMessage, setShowMessage] = useState(false);
  showIcon = !_.isNull(showIcon) && showIcon == false ? false : true;
  htmlText = htmlText.replaceAll("undefined", "");

  const copyToClipboard2 = (item) => {
    navigator.clipboard.writeText(item);
    setShowMessage(true);
  };
  useEffect(() => {
    if (showMessage) {
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 900); // بعد از 2 ثانیه بسته میشه

      return () => clearTimeout(timer); // پاک کردن تایمر در صورت نیاز
    }
  }, [showMessage]);
  return (
    <>
      {/* <p className="mx-3 cursor-pointer " data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید" onClick={() => { copyToClipboard(service?.userOrderSelected?.phoneNumber) }}> <span className="text-hover-primary"> <small className="mx-2 fas fa-phone fa-sm text-hover-primary"></small> {service?.userOrderSelected?.phoneNumber} </span>    </p> */}
      {/* fa-sm text-hover-primary mx-2 */}

      {htmlText && (
        <div style={{ position: "relative", display: "inline-block" }}>
          <div
            dangerouslySetInnerHTML={{ __html: htmlText }}
            onClick={() => {
              copyToClipboard2(copyDate);
            }}
            className="cursor-pointer ltr"
            data-bs-toggle="tooltip"
            title="جهت کپی کلیک شود"
          ></div>
          {showMessage && (
            <span
              className="text-small-1"
              style={{
                position: "absolute",
                top: "50%",
                left: "0",
                minWidth: "60px",
                transform: "translate(0%, -50%)",
                background: "rgba(0,0,0,0.7)",
                color: "white",
                padding: "3px 6px",
                borderRadius: "4px",
                opacity: showMessage ? 1 : 0,
                transition: "opacity 0.5s ease-in-out",
                pointerEvents: "none",
              }}
            >
              کپی شد ✅
            </span>
          )}
        </div>
      )}
      {showIcon && (
        <div
          className="d-inline-block border btn btn-light btn-sm py-1 px-2 rounded ml-2"
          onClick={() => {
            copyToClipboard2(copyDate);
          }}
        >
          <small className="cursor-pointer fas fa-copy"></small>
        </div>
      )}
    </>
  );
};

export default CopyToClipboard;
